import letrusAPI from 'APIs/letrusAPI/axiosInstance';

export const updateProfileService = (userData: any) =>
  letrusAPI(`/api/v1/user_profile/${userData.id}/`, {
    method: 'patch',
    data: {
      ...userData,
    },
  });

export const fetchProfileService = () => letrusAPI(`/api/v1/user_profile/`);
